import React, { useState } from "react";
import newProductsData from "../../data/newProducts";
import "./origen.css";

const Origen = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const openModal = (image) => {
    setSelectedImage(image);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedImage(null);
    setIsModalOpen(false);
  };

  // const handleWhatsAppClick = (product) => {
  //   const phone = "+34695298247";
  //   const message = `Hola, estoy interesado en el producto: ${product.name}.`;
  //   const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
  //   window.open(url, "_blank");
  // };
  return (
    <section id="origen-section">
      <h1 className="products-title">Origen “La esencia del inicio”</h1>
      <p className="new-products-description">
        Candle-le Origen es un regreso a lo esencial. Cada aroma nace del
        encuentro entre la luz y la calma, entre lo natural y lo eterno. Velas
        creadas para reconectar con el silencio, el calor y la esencia de lo
        auténtico.
      </p>

      {isModalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <img
              src={selectedImage}
              alt="Vista ampliada"
              className="modal-image"
            />
          </div>
        </div>
      )}
      <div className="products-container">
        {newProductsData.map((product) => (
          <div key={product.id} className="product-card">
            <img
              src={product.image}
              alt={product.name}
              className="product-image"
              onClick={() => openModal(product.image)}
            />
            <div className="product-info">
              <h3 className="product-name">{product.name}</h3>
              {product.dimensions && (
                <p className="product-dimensions">Peso: {product.dimensions}</p>
              )}
              <p className="product-price">Precio: {product.price}</p>
              {/* <button
                className="whatsapp-button"
                onClick={() => handleWhatsAppClick(product)}
              >
                Contactar por WhatsApp
              </button> */}
            </div>
          </div>
        ))}
      </div>
      <div className="info-card">
        <h2 className="info-title">
          Elige tu aroma, combina tu frasco y crea tu estilo único.
        </h2>

        <p className="info-subtitle">
          Fragancias seleccionadas para despertar emociones y transformar
          cualquier espacio.
        </p>

        <div className="aroma-grid">
          <div className="aroma-item">
            <h4>Mazapán</h4>
            <p>dulce y envolvente</p>
          </div>

          <div className="aroma-item">
            <h4>Pudding de Navidad</h4>
            <p>especiado y festivo</p>
          </div>

          <div className="aroma-item">
            <h4>Lavanda</h4>
            <p>relajante y suave</p>
          </div>

          <div className="aroma-item">
            <h4>Frutos del bosque</h4>
            <p>fresco y afrutado</p>
          </div>

          <div className="aroma-item">
            <h4>Vainilla</h4>
            <p>cálida y clásica</p>
          </div>

          <div className="aroma-item">
            <h4>Maracuyá</h4>
            <p>exótica y refrescante</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Origen;
